import request from '@/utils/request'

// 查询支行分页
export function pageBranch(query) {
  return request({
    url: '/bank/bank-branch/page',
    method: 'get',
    params: query
  })
}
